import { createStyle } from '@gluestack-style/react';

export const Tabs = createStyle({
  width: '100%',
  alignSelf: 'stretch',
});
